import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { Browser } from '@capacitor/browser';
import { ConsentService } from 'src/app/services/consent.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

/**
 * Einwilligungsabfrage fuer Marketing-Speicherung.
 *
 * Bewusst gleichwertige Buttons: die Ablehnung muss genauso leicht erreichbar
 * sein wie die Zustimmung. Ein versteckter oder ausgegrauter Ablehnen-Button
 * waere ein Dark Pattern und macht die Einwilligung angreifbar.
 *
 * Nicht ueber den Backdrop schliessbar - ohne Entscheidung wuerde die Abfrage
 * bei jedem Aufruf erneut erscheinen.
 */
@Component({
  selector: 'app-consent-sheet',
  templateUrl: './consent-sheet.component.html',
  styleUrls: ['./consent-sheet.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule],
})
export class ConsentSheetComponent {
  private modalCtrl = inject(ModalController);
  private consentService = inject(ConsentService);
  private analyticsService = inject(AnalyticsService);

  async acceptAll(): Promise<void> {
    this.consentService.grantMarketing();
    // Die in dieser Sitzung schon erfasste Herkunft darf jetzt dauerhaft
    // gespeichert werden - sonst waere die Zuordnung des laufenden Besuchs
    // verloren, obwohl gerade zugestimmt wurde.
    this.analyticsService.persistFirstTouchAfterConsent();
    await this.modalCtrl.dismiss('granted');
  }

  async acceptNecessary(): Promise<void> {
    this.consentService.denyMarketing();
    await this.modalCtrl.dismiss('denied');
  }

  async openPrivacy(): Promise<void> {
    await Browser.open({ url: 'https://melowish.com/datenschutz/' });
  }
}
